import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.OUT.enumeration<
    graphql.schema.MosaicPageSegmentNavigator,
    ents.core.mosaic.Page.Segment.Navigator
  >({
    [graphql.schema.MosaicPageSegmentNavigator.Scrolling]:
      ents.core.mosaic.Page.Segment.Navigator.Scrolling,
    [graphql.schema.MosaicPageSegmentNavigator.Tabs]:
      ents.core.mosaic.Page.Segment.Navigator.Tabs,
  }),
  graphql.transformers.IN.enumeration<
    ents.core.mosaic.Page.Segment.Navigator,
    graphql.schema.MosaicPageSegmentNavigator
  >({
    [ents.core.mosaic.Page.Segment.Navigator.Scrolling]:
      graphql.schema.MosaicPageSegmentNavigator.Scrolling,
    [ents.core.mosaic.Page.Segment.Navigator.Tabs]:
      graphql.schema.MosaicPageSegmentNavigator.Tabs,
  }),
)
